import React from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import TitleSection from "src/components/TitleSection/TitleSection";

/**
 * Reusable Draw Dates Section for TBCB promotional pages (2026 variants)
 * 
 * @param {Object} props
 * @param {string} props.translationKeyPrefix - The translation key prefix (e.g., "tripleBarrelCashBlast2026")
 * @returns {JSX.Element}
 */
const TBCBDrawDatesSection = ({ translationKeyPrefix }) => {
  const { t } = useTranslation();

  return (
    <>
      <TitleSection
        as={"h4"}
        title={t(`${translationKeyPrefix}.content.drawDates.title`)}
        borderColor="#d59947"
        className="mt-1 pb-2"
      />
      <div className="draw-dates">
        <ReactMarkdown>
          {t(`${translationKeyPrefix}.content.drawDates.one`)}
        </ReactMarkdown>
        <ReactMarkdown>
          {t(`${translationKeyPrefix}.content.drawDates.two`)}
        </ReactMarkdown>
        <ReactMarkdown>
          {t(`${translationKeyPrefix}.content.drawDates.three`)}
        </ReactMarkdown>
      </div>
    </>
  );
};

export default TBCBDrawDatesSection;
